import { Component, EventEmitter, Inject, Input, OnInit, Output, Self, ViewChild, AfterViewInit, ViewChildren, QueryList, ElementRef, OnChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { DialogService } from '../../../../services/dialog.service';
import { DestroyService } from '../../../../services/destroyservice';
import { takeUntil } from 'rxjs';
import { JCobRuleModalComponent } from './jcobrule-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
    selector: 'filemasterdata',
    templateUrl: './filemasterdata.component.html',
    styleUrls: [
        '../../../../style/new-generic-styles.component.less',
        '../../../../style/tables/table-add-butt-header-orange.less',
        './filemasterdata.component.less',
        '../manufacturingsettings.component.less'
    ],
    providers: [DestroyService],
    standalone: false
})
export class FileMasterdataComponent implements OnInit, AfterViewInit, OnChanges {
    public dataSource = new MatTableDataSource<any>();
    @ViewChild(MatTable) objTable!: MatTable<any>;
    @ViewChild(MatSort) sort!: MatSort;

    @ViewChildren('controllerSoftwareInputRef') controllerSoftwareInputRefs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;

    CSRForm!: FormGroup;
    genType: number = 0;
    originalJCOBRulefiles: JcobRuleFileItem[] = [];
    modifiedJCOBRulefiles: JcobRuleFileItem[] = [];
    newJCOBRulefiles: JcobRuleFileItem[] = [];
    uniqueCondition: string[] = [];
    isCallSucceed: number = 0;
    subscriptionStage: any;
    forbiddenchars = ['/', '\\', ':', '*', '?', '<', '>', '|', '"'];
    @Output() controllerSoftwareEvent = new EventEmitter<EMTControllerSoftwareReleaseItem[]>();

    @Input() originalMfgCenterProduct: MFGCenterProductItem[] = [];
    @Input() originalSoftwareReleases: EMTControllerSoftwareReleaseItem[] = [];

    columnsToDisplay = ["RuleFileVersion", "ManufacturingCenterProduct", "ControllerSoftwareVersion", "file", "action"];

    controllerSoftwareInput: string[] = [];
    controllerSoftwareFiltered: EMTControllerSoftwareReleaseItem[][] = [];
    separatorKeysCodes: number[] = [ENTER, COMMA];

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private _formBuilder: FormBuilder,
        private toastrService: ToastrService,
        public defaults: DefaultValuesService,
        private confimDialog: DialogService,
        private dialogForm: MatDialog,
        @Self() private readonly destroy$: DestroyService
    ) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => { this.getJCOBRuleFiles() });
    }

    ngOnChanges() {
        this.getJCOBRuleFiles();
    }

    ngAfterViewInit() {
        this.setupSorting();
    }

    private setupSorting() {
        this.dataSource.sortData = (data, sort) => {
            if (!sort.active || sort.direction === '') {
                return data;
            }
            const isAsc = sort.direction === 'asc';
            return data.slice().sort((a, b) => {
                switch (sort.active) {
                    case 'RuleFileVersion':
                        return (a.ruleFileVersion || '').localeCompare(b.ruleFileVersion || '') * (isAsc ? 1 : -1);
                    case 'ManufacturingCenterProduct':
                        return (this.getManufacturingCenterProductbyId(a.manufacturingCenterProductID) || '')
                            .localeCompare(this.getManufacturingCenterProductbyId(b.manufacturingCenterProductID) || '') * (isAsc ? 1 : -1);
                    case 'ControllerSoftwareVersion':
                        return (this.getControllerSoftwareVersionbyId(a.controllerSoftwareVersionID) || '')
                            .localeCompare(this.getControllerSoftwareVersionbyId(b.controllerSoftwareVersionID) || '') * (isAsc ? 1 : -1);
                    case 'UseforConfigGen':
                        return (a.userForConfigGeneration === b.userForConfigGeneration ? 0 : a.userForConfigGeneration ? -1 : 1) * (isAsc ? 1 : -1);
                    default:
                        return 0;
                }
            });
        };
        this.dataSource.sort = this.sort;
    }

    resetItems() {
        this.genType = 0;
        this.CSRForm = this._formBuilder.group({
            CSRRows: this._formBuilder.array([])
        });
        this.originalJCOBRulefiles.splice(0, this.originalJCOBRulefiles.length);
        this.modifiedJCOBRulefiles.splice(0, this.modifiedJCOBRulefiles.length);
        this.newJCOBRulefiles.splice(0, this.newJCOBRulefiles.length);
        this.dataSource = new MatTableDataSource<any>();
        this.setupSorting();
    }

    getJCOBRuleFiles() {
        this.resetItems();
        Utils.httpGetJCOBReleaseFiles(
            this.http,
            this.baseUrl,
            this,
            (tthis: FileMasterdataComponent, result: any) => {
                tthis.originalJCOBRulefiles = result;
                tthis.originalJCOBRulefiles.length > 0 ? tthis.mapDataToForm(tthis.originalJCOBRulefiles) : null;
            }
        );
    }

    mapDataToForm(data) {
        this.CSRForm = this._formBuilder.group({
            CSRRows: this._formBuilder.array(data.map(val => this._formBuilder.group({
                ruleFileId: new FormControl(val.ruleFileId),
                ruleFileVersion: new FormControl(val.ruleFileVersion),
                manufacturingCenterProductID: new FormControl(val.manufacturingCenterProductID),
                controllerSoftwareVersions: new FormControl(
                    (val.controllerSoftwareVersions ?? []).map((csr) => {
                        const id = typeof csr === 'object' ? csr.controllerSoftwareVersionID : csr;
                        const found = this.originalSoftwareReleases.find(r => r.controllerSoftwareVersionID === id);
                        if (found) return found;
                        if (typeof csr === 'object') {
                            return {
                                controllerSoftwareVersionID: csr.controllerSoftwareVersionID ?? id,
                                controllerSoftwareVersion: csr.controllerSoftwareVersion ?? '',
                                releaseName: (csr.releaseName || csr.ReleaseName || csr.controllerSoftwareVersion || '')
                            };
                        }
                        const byVersion = this.originalSoftwareReleases.find(r => (r.controllerSoftwareVersion || '').toLowerCase() === String(csr || '').toLowerCase());
                        if (byVersion) return byVersion;
                        return { controllerSoftwareVersionID: id, controllerSoftwareVersion: String(csr || ''), releaseName: String(csr || '') };
                    }).filter(Boolean)
                ),
                ruleFile: new FormControl(val.ruleFile),
                ruleFileChanged: new FormControl(false),
                userForConfigGeneration: new FormControl(val.userForConfigGeneration),
                isEditable: new FormControl(true),
                isNewRow: new FormControl(false),
                action: new FormControl('existingRecord'),
            })))
        });
        this.dataSource.data = (this.CSRForm.get('CSRRows') as FormArray).value;

        this.setupSorting();

        this.controllerSoftwareInput = this.dataSource.data.map(() => '');
        this.controllerSoftwareFiltered = this.dataSource.data.map(() => this.originalSoftwareReleases.slice());

    }

    initCSRForm(): FormGroup {
        return this._formBuilder.group({
            ruleFileId: new FormControl(-1),
            ruleFileVersion: new FormControl(""),
            manufacturingCenterProductID: new FormControl(-1),
            controllerSoftwareVersions: new FormControl([]),
            ruleFile: new FormControl(null),
            ruleFileChanged: new FormControl(false),
            userForConfigGeneration: new FormControl(false),
            action: new FormControl('newRecord'),
            isEditable: new FormControl(false),
            isNewRow: new FormControl(true),
        });
    }

    addNewRow() {
        const control = this.CSRForm.get('CSRRows') as FormArray;
        control.insert(0, this.initCSRForm());
        this.dataSource.data = control.value;
        this.setupSorting();
    }

    getCSRRowFormGroup(id: number): FormGroup | null {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        const index = arr.controls.findIndex(
            (group: any) => group.get('ruleFileId')?.value === id
        );
        return index !== -1 ? arr.at(index) as FormGroup : null;
    }

    editRowByID(id: number) {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        const idx = arr.controls.findIndex(
            (group: any) => group.get('ruleFileId')?.value === id
        );
        if (idx !== -1) {
            arr.at(idx).get('isEditable')?.setValue(false);
            this.dataSource.data = arr.value;
        }
    }

    deleteRow(i) {
        const control = this.CSRForm.get('CSRRows') as FormArray;
        control.removeAt(i);
        this.dataSource.data = control.value;
        this.refreshTable();
        this.setupSorting();
    }

    updateFormFeature(index) {
        var obj = this.CSRForm.value.CSRRows;
        var updated = this.originalJCOBRulefiles.find(s => s.ruleFileId == this.CSRForm.value.CSRRows[index]?.ruleFileId);
        obj[index].ruleFileVersion = updated?.ruleFileVersion;
        obj[index].manufacturingCenterProductID = updated?.manufacturingCenterProductID;
        obj[index].ruleFile = updated?.ruleFile;
        obj[index].userForConfigGeneration = updated?.userForConfigGeneration;
        this.controllerSoftwareInput[index] = '';

        obj[index].controllerSoftwareVersions = updated?.controllerSoftwareVersions
            ? (updated.controllerSoftwareVersions ?? []).map((csr: any) => {
                const id = typeof csr === 'object' ? csr.controllerSoftwareVersionID : csr;
                const found = this.originalSoftwareReleases.find(r => r.controllerSoftwareVersionID === id);
                if (found) return found;
                if (typeof csr === 'object') {
                    return {
                        controllerSoftwareVersionID: csr.controllerSoftwareVersionID ?? id,
                        controllerSoftwareVersion: csr.controllerSoftwareVersion ?? '',
                        releaseName: (csr.releaseName || csr.ReleaseName || csr.controllerSoftwareVersion || '')
                    };
                }
                const byVersion = this.originalSoftwareReleases.find(r => (r.controllerSoftwareVersion || '').toLowerCase() === String(csr || '').toLowerCase());
                if (byVersion) return byVersion;
                return { controllerSoftwareVersionID: id, controllerSoftwareVersion: String(csr || ''), releaseName: String(csr || '') };
            }).filter(Boolean)
            : [];

        this.filterControllerSoftwareOptions('', obj[index]);
    }

    openRuleFile(ruleFileId) {
        this.dialogForm.open(JCobRuleModalComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect'],
            data: {
                ruleFileId: ruleFileId,
            },
        });
    }

    refreshTable() {
        this.objTable.renderRows();
    }

    onSave() {
        // Validate no duplicate JCoB Rules before saving
        const duplicates = this.validateNoDuplicateJCoBRules();
        if (duplicates.length > 0) {
            this.confimDialog.showErrorDialog({
                'error': {
                    'message': 'Duplicate JCoB Rule assignments detected:\n\n' + duplicates.join('\n\n') + '\n\nPlease remove the duplicates before saving.'
                }
            });
            return;
        }

        if (this.anyChange()) {

            const releasesChanges = {
                newReleases: this.newJCOBRulefiles,
                modifiedReleases: this.modifiedJCOBRulefiles.map(x => ({ ...x, ruleFile: x.ruleFileChanged ? x.ruleFile : null })),
            };

            releasesChanges.modifiedReleases.forEach(x => {
                x.controllerSoftwareVersionIds = x.controllerSoftwareVersions.map(v => v.controllerSoftwareVersionID);
            });

            releasesChanges.newReleases.forEach(x => {
                x.controllerSoftwareVersionIds = x.controllerSoftwareVersions.map(v => v.controllerSoftwareVersionID);
            });

            Utils.httpUpdateJCOBRuleFiles(
                this.http,
                this.baseUrl,
                releasesChanges,
                this,
                (tthis: FileMasterdataComponent, result: any) => {
                    if (result?.error && result.errorMssg) {
                        tthis.confimDialog.showErrorDialog({
                            'error': { 'message': result.errorMssg }
                        });
                    }
                    tthis.getJCOBRuleFiles();
                    tthis.funcNotify();
                }
            );
        }
    }

    anyChange() {
        this.mapFormToData();
        return (this.modifiedJCOBRulefiles?.length > 0 || this.newJCOBRulefiles?.length > 0);
    }

    /**
     * Validates that there are no duplicate JCoB Rule assignments.
     * A duplicate is defined as the same Manufacturing Center Product + Controller Software Version combination.
     * Returns an array of duplicate descriptions if found, empty array otherwise.
     */
    validateNoDuplicateJCoBRules(): string[] {
        const duplicates: string[] = [];
        const formRows = this.CSRForm.get('CSRRows')?.value || [];
        const seen = new Map<string, any[]>();

        // Build a map of all Manufacturing Center Product + Controller Software Version combinations
        formRows.forEach((row, rowIndex) => {
            if (row.manufacturingCenterProductID !== -1 &&
                row.controllerSoftwareVersions &&
                row.controllerSoftwareVersions.length > 0) {

                row.controllerSoftwareVersions.forEach((csw: any) => {
                    const key = `${row.manufacturingCenterProductID}_${csw.controllerSoftwareVersionID}`;
                    if (!seen.has(key)) {
                        seen.set(key, []);
                    }
                    seen.get(key)!.push({
                        rowIndex,
                        ruleFileVersion: row.ruleFileVersion,
                        mcpName: this.getManufacturingCenterProductbyId(row.manufacturingCenterProductID),
                        cswName: csw.ReleaseName
                    });
                });
            }
        });

        // Check for duplicates
        seen.forEach((rows, key) => {
            if (rows.length > 1) {
                const mcpName = rows[0].mcpName;
                const cswName = rows[0].cswName;
                const versions = rows.map(r => r.ruleFileVersion || '(empty)').join(', ');
                duplicates.push(
                    `Manufacturing Center Product "${mcpName}" with Controller Software "${cswName}" is assigned to multiple rules: ${versions}`
                );
            }
        });

        return duplicates;
    }

    mapFormToData() {
        this.modifiedJCOBRulefiles = this.CSRForm.get('CSRRows')?.value.filter(row =>
            !row.isNewRow
            && !row.isEditable
            && row.manufacturingCenterProductID !== -1
            && row.controllerSoftwareVersions && row.controllerSoftwareVersions.length >= 0
            && row.ruleFileVersion !== "" && row.ruleFileVersion.length <= 30
        ).map(row => ({
            ...row,
            controllerSoftwareVersionID: row.controllerSoftwareVersions[0]?.controllerSoftwareVersionID || null
        }));
        this.newJCOBRulefiles = this.CSRForm.get('CSRRows')?.value.filter(row =>
            row.isNewRow
            && row.manufacturingCenterProductID !== -1
            && row.controllerSoftwareVersions && row.controllerSoftwareVersions.length > 0
            && row.ruleFileVersion !== "" && row.ruleFileVersion.length <= 30
            && row.ruleFile != null
        ).map(row => ({
            ...row,
            controllerSoftwareVersionID: row.controllerSoftwareVersions[0]?.controllerSoftwareVersionID || null
        }));

        this.uniqueCondition = this.findObjWithMultipleActive(this.CSRForm.get('CSRRows')?.value)

    }

    findObjWithMultipleActive(items): string[] {
        const itemCounts = items.reduce((acc, item) => {
            if (item.userForConfigGeneration && item.controllerSoftwareVersions && item.controllerSoftwareVersions.length > 0) {
                item.controllerSoftwareVersions.forEach((version: any) => {
                    const key = version.controllerSoftwareVersionID.toString() + item.manufacturingCenterProductID.toString();
                    if (!acc[key]) {
                        acc[key] = 0;
                    }
                    acc[key]++;
                });
            }
            return acc;
        }, {} as { [key: string]: number });

        return Object.keys(itemCounts).filter(itemName => itemCounts[itemName] > 1);
    }

    checkInput(event) {
        if (this.forbiddenchars.some(x => x === event.key))
            event.preventDefault();
    }

    getManufacturingCenterProductbyId(id) {
        var result = this.originalMfgCenterProduct.find(x => x.manufacturingCenterProductID == id);
        return result ? `${result.mfgCenter} - ${result.productCode} - ${result.productName}` : "";
    }
    getControllerSoftwareVersionbyId(id): string {
        var result = this.originalSoftwareReleases.find(x => x.controllerSoftwareVersionID == id);
        return result ? result.releaseName : "";
    }

    onCheckboxChange(event: any, ruleFileId: number): void {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        const idx = arr.controls.findIndex(
            (group: any) => group.get('ruleFileId')?.value === ruleFileId
        );
        if (idx === -1) return;

        const currentGroup = arr.at(idx) as FormGroup;
        const currentProductId = currentGroup.get('manufacturingCenterProductID')?.value;
        const currentSoftwareId = currentGroup.get('controllerSoftwareVersionID')?.value;

        if (event.checked) {
            // Uncheck all with same product/software
            arr.controls.forEach((group: any) => {
                if (
                    group.get('manufacturingCenterProductID')?.value === currentProductId &&
                    group.get('controllerSoftwareVersionID')?.value === currentSoftwareId
                ) {
                    group.get('userForConfigGeneration')?.setValue(false);
                }
            });
        }
        currentGroup.get('userForConfigGeneration')?.setValue(event.checked);
    }

    toggleOvl(index) {
        this.CSRForm.value.CSRRows[index].isOpenOverlay = !this.CSRForm.value.CSRRows[index].isOpenOverlay;
    }


    getFileUploadId(index) {
        return `fu_${index}`;
    }

    onFileChange(event: any, index) {
        const reader = new FileReader();
        const file = event.target.files[0];
        if (file) {
            reader.onload = (e: any) => {
                const xmlContent = e.target.result;
                this.assignToRuleFile(xmlContent, index);
            };
            reader.readAsText(file);
        }
    }

    assignToRuleFile(xmlContent: string, index) {
        this.CSRForm.value.CSRRows[index].ruleFile = xmlContent;
        this.CSRForm.value.CSRRows[index].ruleFileChanged = true;
    }    

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Save request successfully sent!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Save action could not be performed. Please, contact with administrator');
        }
    }

    // Controller Software Version chip-list management
    filterControllerSoftwareOptions(input: string, element: any) {
        const current = element.controllerSoftwareVersions || [];
        const rowIndex = this.dataSource.data.indexOf(element);

        if (rowIndex !== -1) {
            this.controllerSoftwareFiltered[rowIndex] = this.originalSoftwareReleases.filter(
                opt =>
                    (opt.releaseName || '').toLowerCase().includes(String(input || '').toLowerCase()) &&
                    !current.some((c: any) => c.controllerSoftwareVersionID === opt.controllerSoftwareVersionID)
            );
        }
    }

    addControllerSoftwareFromInput(event: any, element: any) {
        const input = event.input;
        const value = event.value?.trim();
        if (value) {
            const found = this.originalSoftwareReleases.find(
                r => (r.releaseName || '').toLowerCase() === value.toLowerCase()
            );
            if (found) {
                const currentMCP = element.manufacturingCenterProductID;
                const isAlreadyAssigned = this.dataSource.data.some(row =>
                    row !== element &&
                    row.manufacturingCenterProductID === currentMCP &&
                    Array.isArray(row.controllerSoftwareVersions) &&
                    row.controllerSoftwareVersions.some((c: any) => c.controllerSoftwareVersionID === found.controllerSoftwareVersionID)
                );
                if (isAlreadyAssigned) {
                    this.toastrService.warning(
                        'This controller software version is already assigned to another rule for the same Manufacturing Center Product.',
                        'Duplicate not allowed'
                    );
                } else if (!element.controllerSoftwareVersions.some((c: any) => c.controllerSoftwareVersionID === found.controllerSoftwareVersionID)) {
                    element.controllerSoftwareVersions.push(found);
                }
            }
        }
        const rowIndex = this.dataSource.data.indexOf(element);
        if (rowIndex !== -1) {
            this.controllerSoftwareInput[rowIndex] = '';
            this.filterControllerSoftwareOptions('', element);
            setTimeout(() => {
                const inputRef = this.controllerSoftwareInputRefs?.toArray()[rowIndex];
                if (inputRef) {
                    inputRef.nativeElement.value = '';
                }
            });
        }
        if (input) input.value = '';
    }

    onMCPChange(element: any, rowIndex?: number) {
        if (!element.manufacturingCenterProductID || !element.controllerSoftwareVersions) return;

        const conflicts = element.controllerSoftwareVersions.filter((csw: any) =>
            this.dataSource.data.some(row =>
                row !== element &&
                row.manufacturingCenterProductID === element.manufacturingCenterProductID &&
                Array.isArray(row.controllerSoftwareVersions) &&
                row.controllerSoftwareVersions.some((c: any) => c.controllerSoftwareVersionID === csw.controllerSoftwareVersionID)
            )
        );

        if (conflicts.length > 0) {
            this.toastrService.warning(
                'Some controller software versions are already assigned to another rule for this Manufacturing Center Product. They will be removed.',
                'Duplicate not allowed'
            );
            // Remove conflicting controller software versions
            element.controllerSoftwareVersions = element.controllerSoftwareVersions.filter((csw: any) =>
                !conflicts.some((conflict: any) => conflict.controllerSoftwareVersionID === csw.controllerSoftwareVersionID)
            );
            // If using reactive forms, update the form control:
            if (rowIndex !== undefined) {
                const arr = this.CSRForm.get('CSRRows') as FormArray;
                arr.at(rowIndex).get('controllerSoftwareVersions')?.setValue(element.controllerSoftwareVersions);
            }
        }
    }

    selectedControllerSoftware(event: MatAutocompleteSelectedEvent, element: any) {
        const selectedId = event.option.value;
        const selected = this.originalSoftwareReleases.find(r => r.controllerSoftwareVersionID === selectedId);
        if (selected) {
            const currentMCP = element.manufacturingCenterProductID;
            const isAlreadyAssigned = this.dataSource.data.some(row =>
                row !== element &&
                row.manufacturingCenterProductID === currentMCP &&
                Array.isArray(row.controllerSoftwareVersions) &&
                row.controllerSoftwareVersions.some((c: any) => c.controllerSoftwareVersionID === selected.controllerSoftwareVersionID)
            );
            if (isAlreadyAssigned) {
                this.toastrService.warning(
                    'This controller software version is already assigned to another rule for the same Manufacturing Center Product.',
                    'Duplicate not allowed'
                );
            } else if (!element.controllerSoftwareVersions.some((c: any) => c.controllerSoftwareVersionID === selected.controllerSoftwareVersionID)) {
                element.controllerSoftwareVersions.push(selected);
            }
        }
        const rowIndex = this.dataSource.data.indexOf(element);
        if (rowIndex !== -1) {
            this.controllerSoftwareInput[rowIndex] = '';
            this.filterControllerSoftwareOptions('', element);
            setTimeout(() => {
                const inputRef = this.controllerSoftwareInputRefs?.toArray()[rowIndex];
                if (inputRef) {
                    inputRef.nativeElement.value = '';
                }
            });
        }
    }

    removeControllerSoftware(element: any, j: number) {
        element.controllerSoftwareVersions.splice(j, 1);
        const rowIndex = this.dataSource.data.indexOf(element);
        if (rowIndex !== -1) {
            this.filterControllerSoftwareOptions(this.controllerSoftwareInput[rowIndex], element);
        }
    }

    openControllerSoftwareAutocomplete(element: any, index: number) {
        if (!this.controllerSoftwareInput[index] || this.controllerSoftwareInput[index].trim() === '') {
            this.filterControllerSoftwareOptions(this.controllerSoftwareInput[index], element);
        }
        setTimeout(() => {
            const trigger = this.autocompleteTriggers?.toArray()[index];
            if (trigger && this.controllerSoftwareFiltered[index]?.length > 0) {
                trigger.openPanel();
            }
        });
    }

    resetRowByID(id: number) {
        const arr = this.CSRForm.get('CSRRows') as FormArray;
        const idx = arr.controls.findIndex(
            (group: any) => group.get('ruleFileId')?.value === id
        );
        if (idx !== -1) {
            const isNewRow = arr.at(idx).get('isNewRow')?.value;
            if (isNewRow) {
                arr.removeAt(idx);
            } else {
                const original = this.originalJCOBRulefiles.find(
                    s => s.ruleFileId === id
                );
                if (original) {
                    arr.at(idx).patchValue({
                        ruleFileVersion: original.ruleFileVersion,
                        manufacturingCenterProductID: original.manufacturingCenterProductID,
                        controllerSoftwareVersions: (original.controllerSoftwareVersions ?? []).map((csr: any) => {
                            const id = typeof csr === 'object' ? csr.controllerSoftwareVersionID : csr;
                            const found = this.originalSoftwareReleases.find(r => r.controllerSoftwareVersionID === id);
                            if (found) return found;
                            if (typeof csr === 'object') {
                                return {
                                    controllerSoftwareVersionID: csr.controllerSoftwareVersionID ?? id,
                                    controllerSoftwareVersion: csr.controllerSoftwareVersion ?? '',
                                    releaseName: (csr.releaseName || csr.ReleaseName || csr.controllerSoftwareVersion || '')
                                };
                            }
                            const byVersion = this.originalSoftwareReleases.find(r => (r.controllerSoftwareVersion || '').toLowerCase() === String(csr || '').toLowerCase());
                            if (byVersion) return byVersion;
                            return { controllerSoftwareVersionID: id, controllerSoftwareVersion: String(csr || ''), releaseName: String(csr || '') };
                        }).filter(Boolean),
                        ruleFile: original.ruleFile,
                        userForConfigGeneration: original.userForConfigGeneration
                    });
                }
                arr.at(idx).get('isEditable')?.setValue(true);
                this.controllerSoftwareInput[idx] = '';
                this.filterControllerSoftwareOptions('', arr.at(idx).value);
                setTimeout(() => {
                    const inputRef = this.controllerSoftwareInputRefs?.toArray()[idx];
                    if (inputRef) {
                        inputRef.nativeElement.value = '';
                    }
                });
            }
            this.dataSource.data = arr.value;
        }
    }

    getControllerSoftwareVersionText(versions: any[]): string {
        if (!versions || versions.length === 0) return '';
        return versions.map(v => v.releaseName).join(', ');
    }
}
